import api from "@/lib/api";
import { useQuery } from "@tanstack/react-query";

export function useOutboundVisible() {
  const { data } = useQuery({ queryKey: ["outbound-visible"], staleTime: 300000,
    queryFn: () => api.get("/outbound/visibility").then((r) => !!r.data.visible).catch(() => false) });
  return data;   // undefined while loading, then true/false
}

export const inr = (p) => (p == null ? "—" : `₹${(p / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const when = (s) => (s ? new Date(s).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" }) : "—");
export const STATUS = { queued: "Queued", dialing: "Dialling", in_progress: "In progress", completed: "Completed", no_answer: "Unanswered",
  busy: "Busy", failed: "Failed", opted_out: "Opted out", cancelled: "Cancelled", skipped: "Skipped" };
export const CAMP_STATUS = { draft: "Draft", awaiting_approval: "Awaiting approval", ready: "Ready", running: "Active", paused: "Paused",
  completed: "Completed", cancelled: "Cancelled", archived: "Archived" };

export async function saveFile(url, name) {
  const r = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = name;
  a.click();
  URL.revokeObjectURL(a.href);
}

export async function download(fmt) {
  const r = await api.get(`/outbound/template?fmt=${fmt}`, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = `pawkt_outbound_contacts.${fmt}`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function Stat({ k, v, id, tone = "" }) {
  return (
    <div className={`rounded-xl border border-slate-200 bg-white p-3 ${tone}`}>
      <p className="text-xs text-slate-500">{k}</p>
      <p className="text-lg font-bold" data-testid={id}>{v}</p>
    </div>
  );
}

export function Table({ head, rows, id, empty }) {
  if (!rows.length) return <p className="rounded-xl bg-slate-50 p-3 text-xs text-slate-500" data-testid={`${id}-empty`}>{empty}</p>;
  return (
    <div className="w-full max-w-full overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table className="w-full min-w-max text-xs" data-testid={id}>
        <thead className="bg-slate-50 text-left"><tr>{head.map((h) => <th key={h} className="p-2 font-semibold">{h}</th>)}</tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} className="border-t" data-testid={`${id}-row-${i}`}>{r.map((c, j) => <td key={j} className="p-2 align-top">{c}</td>)}</tr>)}</tbody>
      </table>
    </div>
  );
}
